/*
 * biobio-pdp-v2.js: Web Component <pdp-cta> da PDP v2.
 * Botao repetido (apos o FAQ) e barra fixa no celular. Os dois DELEGAM o clique
 * ao botao real do <pdp-offer> ([data-pdp-add-to-cart]), para reaproveitar o
 * caminho de carrinho (line items, gaveta). Se o botao da oferta esta travado
 * ou escondido (esgotado, avise-me), nada e adicionado: a pagina rola ate a
 * oferta. A barra e montada direto no body: no iOS, position:fixed dentro de
 * trilho ou carrossel vira estatico. Gaveta aberta (classe show-cart-summary
 * que o theme.js alterna) esconde a barra. Medicao por dataLayer (GTM do app
 * Stape roda na janela principal), nao por property de line item: o offer
 * monta os itens e a Yampi perde linhas do carrinho.
 * Preco espelha o [data-pdp-total] da oferta; vazio ou ausente, vale o Liquid. Na oferta
 * com tons (pdp-offer--tons, a Base): "Escolha seu tom" antes do tom e, com ele, o total
 * com o "de" riscado da oferta ([data-pdp-compare]) quando houver desconto.
 * Barra que escolhe o tom (spec 2026-10-27-barra-tom), só com pdp-offer--tons: a barra aparece
 * também sem tom e com a combinação indisponível (motivoBloqueio), mostra o estado do tom
 * (rotuloBarra) e se redesenha uma vez por quadro de animação, depois de o quadro assentar.
 * Gaveta de tom (mesma spec, 4.2 a 4.4): um <dialog> no body, aberto pela barra, com as pílulas de degrau, as
 * bolinhas clonadas do quadro e o rodapé que espelha o botão dele. Não guarda estado: toda ação dela é uma ação no
 * <pdp-offer>, e o desenho vem do quadro assentado.
 *
 * Em Node (testes) o arquivo so publica globalThis.BiobioPdpV2 e sai.
 */
(function () {
  'use strict';

  // Estado puro da barra: testavel sem DOM.
  // s = { ligada, largura, ofertaVisivel, gavetaAberta, carrinhoAtualizando, ofertaBloqueada, mostraComBloqueio }
  // mostraComBloqueio (só na oferta com tons): a oferta está travada só porque falta o tom, ou com os tons
  // completos numa combinação indisponível; aí a barra é o lugar de escolher e não se esconde. Sem o campo, o
  // de sempre.
  function estadoBarra(s) {
    if (!s.ligada) return false;
    if (s.largura >= 1024) return false;
    if (s.gavetaAberta) return false;
    if (s.carrinhoAtualizando) return false;
    if (s.ofertaBloqueada && !s.mostraComBloqueio) return false;
    return !s.ofertaVisivel;
  }

  // Por que o botão do quadro não compra agora (oferta com tons). s = { botao, isComplete, tierIndisponivel,
  // aviseVisivel, comprando }. null = comprável; 'sem-tom' = travado com tom por escolher; 'indisponivel' = tons
  // completos e o quadro travado (degrau por kit sem a combinação ou sem estoque, tierBloqueado); 'esgotado' =
  // avise-me no lugar do botão; 'tier-indisponivel' = degrau marcado sem caminho de compra; 'comprando' = add em
  // curso. Sem o botão ou sem o isComplete do quadro (script dele por carregar), 'quadro-nao-pronto': nunca
  // comprável.
  function motivoBloqueio(s) {
    var b = s.botao;
    if (!b || typeof s.isComplete !== 'boolean') return 'quadro-nao-pronto';
    if (s.comprando) return 'comprando';
    if (s.tierIndisponivel) return 'tier-indisponivel';
    if (s.aviseVisivel) return 'esgotado';
    var travado = !!b.disabled || (typeof b.getAttribute === 'function' && b.getAttribute('aria-disabled') === 'true');
    if (!travado) return null;
    return s.isComplete ? 'indisponivel' : 'sem-tom';
  }

  // R76: a oferta "não passou" enquanto está na tela OU ainda abaixo dela (topo positivo). Só
  // depois de a pessoa rolar além dela (topo negativo, fora da tela) a barra pode aparecer.
  // e = IntersectionObserverEntry (isIntersecting, boundingClientRect.top) ou só { boundingClientRect }.
  function ofertaNaoPassou(e) {
    return Boolean(e.isIntersecting || e.boundingClientRect.top > 0);
  }

  // Preço do botão repetido e da barra (P7 da prévia de 22/10, decisão do Breno). Na oferta com tons (classe
  // pdp-offer--tons, que o snippet só põe com ajuda_tom: a Base), cada tom tem um preço: antes de escolher o
  // tom, "Escolha seu tom" no lugar do preço; com o tom, o total da oferta, com o "de" riscado quando a oferta
  // mostra um ([data-pdp-compare] visível). Sem a classe, o de sempre: o total quando ele tem texto, senão o
  // Liquid. Na oferta por kit sem tom (pdp-offer--r2, as PDPs VIP) só o "de" riscado vale; o "Escolha seu tom"
  // fica com a Base. s = { tons, r2, completo, total, de, rotulo }. Devolve null (volta ao Liquid), { texto } ou { html }.
  // Palavra da variante no vocabulário da barra e da gaveta (setting rotulo_variante da oferta, impresso no host
  // como data-rotulo-variante): 'tom' (a Base) ou 'cor' (o BBS). Qualquer outro valor, ou nenhum, é 'tom'.
  // ord é o ordinal que se cola à própria palavra da variante.
  function vocab(rotulo) {
    if (rotulo === 'cor') return { nome: 'cor', seu: 'sua cor', o: 'a cor', cap: 'Cor', ord: '\u00aa', plural: 'cores' };
    return { nome: 'tom', seu: 'seu tom', o: 'o tom', cap: 'Tom', ord: '\u00ba', plural: 'tons' };
  }

  function escapar(t) {
    return String(t).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
  }

  function precoCta(s) {
    if (!s.tons && !s.r2) return s.total ? { texto: s.total } : null;
    if (s.tons && !s.completo) return { html: '<span class="pdp-cta__escolha">Escolha ' + vocab(s.rotulo).seu + '</span>' };
    if (!s.total) return null;
    if (!s.de) return { texto: s.total };
    return { html: '<s class="pdp-cta__de"><span class="visually-hidden">De </span>' + escapar(s.de) + '</s> <span class="pdp-cta__por"><span class="visually-hidden">por </span>' + escapar(s.total) + '</span>' };
  }

  // Preço do rodapé da gaveta de tom: o total vivo do quadro, com o "de" riscado numa linha própria quando a oferta
  // mostra um (o CSS põe cada um em bloco). Ao contrário do precoCta, sai também com o tom por escolher: o quadro já
  // calcula o total do degrau antes do tom. Vazio só sem total. O "R$" fica preso ao número por um espaço que não
  // quebra. s = { total, de }. Devolve html.
  function semQuebra(t) {
    return String(t || '').trim().split('R$ ').join('R$\u00a0');
  }

  function precoGaveta(s) {
    var total = semQuebra(s && s.total);
    if (!total) return '';
    var de = semQuebra(s.de);
    if (!de) return '<span class="pdp-tom__por">' + escapar(total) + '</span>';
    return '<s class="pdp-tom__de"><span class="visually-hidden">De </span>' + escapar(de) + '</s>' +
      '<span class="pdp-tom__por"><span class="visually-hidden">por </span>' + escapar(total) + '</span>';
  }

  // Rótulo próprio da barra e da gaveta (campo opcional rotulo_barra do degrau, impresso pelo snippet da oferta como
  // data-rotulo-barra): vence o nome do degrau do quadro, que não muda. Vazio ou só espaço, devolve ''.
  function rotuloDaBarra(card) {
    return card && card.getAttribute ? String(card.getAttribute('data-rotulo-barra') || '').trim() : '';
  }

  // Lado esquerdo e botão da barra com tons. s = { tons, motivo, qtd, unidades, rotuloDegrau, nome }: unidades =
  // uma por unidade do degrau marcado (no modo direto, uma), { nome, estilo } do tom escolhido ou null; qtd = a
  // quantidade do stepper do modo direto (1 nos cards); rotuloDegrau = o nome do degrau marcado (vazio no modo
  // direto); nome = o nome curto do produto; rotulo = 'tom' ou 'cor'. Sem tons, null (a barra de sempre). estilo é o style inline da
  // .swatch do quadro (--swatch-bg / --swatch-image). Devolve { esquerda: html, botao: { texto, classe, acao,
  // desabilitado? } }; acao 'abrir' abre a gaveta de tom, 'comprar' delega ao botão do quadro.
  function rotuloBarra(s) {
    if (!s || !s.tons) return null;
    var v = vocab(s.rotulo);
    var unidades = s.unidades || [];
    var incompleta = !unidades.length || unidades.some(function (u) { return !u || !u.nome; });
    if (s.motivo === 'sem-tom' || incompleta) {
      var nome = '<span class="pdp-cta__barra-nome">' + escapar(s.nome || '') + '</span>';
      // O degrau e o preço ficam para a gaveta: a barra sem escolha mostra a miniatura e o nome (Breno, 31/10).
      // Com a miniatura sobra menos largura: o complemento do kit (": 2 unidades") sai, porque a gaveta já o diz. O "FPS"
      // fica na mesma linha do número (espaço que não quebra).
      if (s.thumb) nome = '<span class="pdp-cta__barra-produto"><img class="pdp-cta__thumb pdp-cta__thumb--barra" src="' + escapar(s.thumb) + '" width="44" height="44" alt=""><span class="pdp-cta__barra-nome">' + escapar(String(s.nome || '').split(':')[0].replace(/FPS (\d)/g, 'FPS\u00a0$1')) + '</span></span>';
      return { esquerda: nome, botao: { texto: 'Escolha ' + v.seu, classe: 'pdp-cta__botao--tom', acao: 'abrir' } };
    }
    var marca, texto, trocar;
    if (unidades.length > 1) {
      marca = '<span class="pdp-cta__barra-pontinhos" aria-hidden="true">' + unidades.map(function (u) {
        return '<i style="' + escapar(u.estilo || '') + '"></i>';
      }).join('') + '</span>';
      texto = unidades.length + ' ' + v.plural;
      trocar = 'Trocar';
    } else {
      marca = '<span class="pdp-cta__barra-bolinha" style="' + escapar(unidades[0].estilo || '') + '" aria-hidden="true"></span>';
      texto = (s.qtd > 1 ? s.qtd + ' × ' : '') + unidades[0].nome;
      trocar = 'Trocar ' + v.o;
    }
    var esquerda = '<button type="button" class="pdp-cta__barra-trocar" data-pdp-tom-abrir>' + marca +
      '<span class="pdp-cta__barra-tomnome">' + escapar(texto) + '</span><span class="pdp-cta__barra-trocar-txt">' + trocar + '</span></button>';
    var botao = s.motivo === 'indisponivel'
      ? { texto: 'Comprar agora', classe: 'pdp-cta__botao--comprar', acao: 'abrir', desabilitado: true }
      : { texto: 'Comprar agora', classe: 'pdp-cta__botao--comprar', acao: 'comprar' };
    return { esquerda: esquerda, botao: botao };
  }

  var api = { estadoBarra: estadoBarra, ofertaNaoPassou: ofertaNaoPassou, precoCta: precoCta, motivoBloqueio: motivoBloqueio, rotuloBarra: rotuloBarra, precoGaveta: precoGaveta, vocab: vocab };
  if (typeof globalThis !== 'undefined') globalThis.BiobioPdpV2 = api;
  if (typeof customElements === 'undefined' || typeof document === 'undefined') return;
  if (customElements.get('pdp-cta')) return;

  var GAVETA_ABERTA = 'show-cart-summary';
  var CARRINHO_ATUALIZANDO = 'updating-cart';
  // A mesma classe da gaveta do Trio (biobio-trio.css): overflow hidden em html e body.
  var SEM_ROLAGEM = 'biobio-trio-noscroll';
  // Aviso da gaveta de tom com os tons completos e o quadro travado (indisponível ou esgotado).
  function avisoTom(v) {
    return 'Essa combinação está esgotada. Escolha ' + (v.nome === 'cor' ? 'outra cor' : 'outro tom') + '.';
  }
  var precoLiquid = new WeakMap();
  var precoHtml = new WeakMap();

  function gavetaAberta() {
    return document.documentElement.classList.contains(GAVETA_ABERTA) || document.body.classList.contains(GAVETA_ABERTA);
  }

  // Add em curso, do toque até a gaveta abrir. O botão da oferta fica disabled só durante o
  // POST /cart/add.js e destrava assim que a resposta chega; a gaveta (show-cart-summary) abre
  // depois, quando o $.get do theme.js volta. Nesse meio o theme.js já pôs updating-cart no body
  // (cartLoadingStarted, antes de a oferta destravar) e só tira 500 ms depois de abrir a gaveta.
  // Tratado como gaveta aberta, a barra não volta entre o toque e a gaveta, onde um segundo toque
  // adicionaria de novo. Se o add falha, o theme.js nem entra: a oferta destrava e a barra volta.
  function carrinhoAtualizando() {
    return document.body.classList.contains(CARRINHO_ATUALIZANDO);
  }

  function reduzMovimento() {
    return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  // Escreve um resultado do precoCta num alvo de preço (card ou barra); null volta ao preço do Liquid.
  function escreverPreco(r) {
    return function (el) {
      if (!precoLiquid.has(el)) precoLiquid.set(el, el.innerHTML);
      if (r && r.html !== undefined) {
        if (precoHtml.get(el) !== r.html) {
          el.innerHTML = r.html;
          precoHtml.set(el, r.html);
        }
        return;
      }
      precoHtml.delete(el);
      if (r) {
        if (el.textContent !== r.texto) el.textContent = r.texto;
      } else if (el.innerHTML !== precoLiquid.get(el)) {
        el.innerHTML = precoLiquid.get(el);
      }
    };
  }

  // Tom escolhido numa fileira do quadro para o rotuloBarra: a .swatch da variante do snapshot (a que vai para o
  // carrinho), ou a marcada; o nome (option value) e o style inline com a cor já resolvida.
  function unidadeDe(raiz, id) {
    if (id == null || !raiz) return null;
    var sw = raiz.querySelector('.swatch[data-variant-id="' + Number(id) + '"]') || raiz.querySelector('.swatch--selected');
    var nome = sw ? sw.getAttribute('data-option-value') : '';
    return nome ? { nome: nome, estilo: sw.getAttribute('style') || '' } : null;
  }

  // Elemento da gaveta de tom: atributos e, se houver, o texto.
  function criar(tag, attrs, texto) {
    var el = document.createElement(tag);
    Object.keys(attrs).forEach(function (k) { el.setAttribute(k, attrs[k]); });
    if (texto) el.textContent = texto;
    return el;
  }

  // Texto visível de um elemento do quadro, com os espaços normalizados (rótulo de degrau e de unidade).
  function textoDe(el) {
    return el ? String(el.textContent || '').replace(/\s+/g, ' ').trim() : '';
  }

  class PdpCta extends HTMLElement {
    connectedCallback() {
      if (this.ligado) return;
      this.ligado = true;
      this.oferta = document.querySelector('pdp-offer');
      this.botaoOferta = this.oferta ? this.oferta.querySelector('[data-pdp-add-to-cart]') : null;
      if (!this.oferta) {
        this.hidden = true;
        this.escondidoSemOferta = true;
        return;
      }
      this.cliques = [];
      this.querySelectorAll('[data-pdp-cta-botao]').forEach(function (b) {
        var aoClicar = this.comprar.bind(this, b.dataset.origem || 'repetido');
        b.addEventListener('click', aoClicar);
        this.cliques.push([b, aoClicar]);
      }, this);
      this.montarBarra();
      this.ligarPreco();
      if (this.ofertaComTons()) {
        this.ligarTons();
        this.montarGaveta();
      }
    }

    // Oferta com tons: a barra se redesenha depois de o quadro assentar. Os eventos do quadro saem antes do
    // computeAll/updateState dele, então só agendam; o stepper do modo direto muda a quantidade sem evento. Na
    // partida, o whenDefined cobre o script da oferta que chega depois deste (o disabled que ela põe ao
    // inicializar também passa pelo moTrava).
    ligarTons() {
      var self = this;
      this.aoMudarQuadro = function () { self.agendarRedesenho(); };
      document.addEventListener('pdp-offer:variant-changed', this.aoMudarQuadro);
      document.addEventListener('pdp-offer:tier-changed', this.aoMudarQuadro);
      this.stepperQuadro = this.oferta.querySelector('[data-pdp-stepper]');
      if (this.stepperQuadro) this.stepperQuadro.addEventListener('click', this.aoMudarQuadro);
      if (typeof customElements !== 'undefined' && typeof customElements.whenDefined === 'function') {
        customElements.whenDefined('pdp-offer').then(this.aoMudarQuadro);
      }
    }

    disconnectedCallback() {
      this.desmontarGaveta();
      if (this.io) this.io.disconnect();
      if (this.mo) this.mo.disconnect();
      if (this.moTrava) this.moTrava.disconnect();
      if (this.moPreco) this.moPreco.disconnect();
      if (this.aoRedimensionar) window.removeEventListener('resize', this.aoRedimensionar);
      if (this.aoRolar) window.removeEventListener('scroll', this.aoRolar);
      if (this.quadroRolagem) window.cancelAnimationFrame(this.quadroRolagem);
      this.aoRolar = null;
      this.quadroRolagem = 0;
      if (this.aoMudarQuadro) {
        document.removeEventListener('pdp-offer:variant-changed', this.aoMudarQuadro);
        document.removeEventListener('pdp-offer:tier-changed', this.aoMudarQuadro);
        if (this.stepperQuadro) this.stepperQuadro.removeEventListener('click', this.aoMudarQuadro);
      }
      if (this.quadroRedesenho && typeof window.cancelAnimationFrame === 'function') window.cancelAnimationFrame(this.quadroRedesenho);
      this.aoMudarQuadro = this.stepperQuadro = null;
      this.quadroRedesenho = 0;
      this.redesenhoAgendado = false;
      this.barraTom = this.barraTomHtml = this.nomeBarra = null;
      (this.cliques || []).forEach(function (par) { par[0].removeEventListener('click', par[1]); });
      this.io = this.mo = this.moTrava = this.moPreco = this.aoRedimensionar = null;
      this.cliques = [];
      if (this.barra) {
        if (!this.barra.hidden) document.body.classList.remove('pdp-cta-barra-visivel');
        if (this.barra.parentNode) this.barra.parentNode.removeChild(this.barra);
        this.barra = null;
      }
      if (this.escondidoSemOferta) {
        this.hidden = false;
        this.escondidoSemOferta = false;
      }
      this.ligado = false;
    }

    // Quadro de compra inicializado: o script do <pdp-offer> já pôs os métodos no elemento. Antes disso (SSR, o
    // botão vem habilitado com o texto de compra), nada do quadro é lido e a barra com tons fica escondida.
    quadroPronto() {
      var o = this.oferta;
      return !!o && typeof o.isComplete === 'function' && typeof o.snapshotSelected === 'function' && typeof o.onSwatch === 'function';
    }

    motivo() {
      if (!this.quadroPronto()) return 'quadro-nao-pronto';
      var o = this.oferta;
      var b = this.botaoOferta;
      var tier = typeof o.getCheckedTier === 'function' ? o.getCheckedTier() : null;
      var avise = o.querySelector('[data-pdp-avise]');
      return motivoBloqueio({
        botao: b,
        isComplete: !!o.isComplete(),
        tierIndisponivel: !!(tier && tier.dataset && tier.dataset.tierIndisponivel === '1'),
        // Avise-me à mostra, ou o botão do quadro escondido (o avise-me no lugar dele): esgotado.
        aviseVisivel: !!(avise && !avise.hidden) || !!(b && b.offsetParent === null),
        comprando: !!(o.classList && o.classList.contains('pdp-offer--adding')),
      });
    }

    // Nome curto do produto, lido do template da barra antes da primeira reescrita.
    nomeCurto() {
      if (this.nomeBarra == null && this.barra) {
        var n = this.barra.querySelector('.pdp-cta__barra-nome');
        this.nomeBarra = n ? String(n.textContent || '').trim() : '';
      }
      return this.nomeBarra || '';
    }

    // Miniatura do template da barra (setting mostrar_thumb), lida antes da primeira reescrita, que a tira do lugar.
    thumbBarra() {
      if (this.thumbSrc == null && this.barra) {
        var t = this.barra.querySelector('.pdp-cta__thumb--barra');
        this.thumbSrc = t && t.getAttribute ? String(t.getAttribute('src') || '') : '';
      }
      return this.thumbSrc || '';
    }

    // Palavra da variante lida do host da oferta: 'tom' (sem o atributo) ou 'cor'.
    rotuloVariante() {
      var r = this.oferta && this.oferta.getAttribute ? this.oferta.getAttribute('data-rotulo-variante') : null;
      return vocab(r).nome;
    }

    // Entrada do rotuloBarra, lida do quadro assentado: os tons escolhidos (snapshotSelected e as .swatch--selected
    // de cada unidade do degrau marcado), o nome do degrau marcado e, no modo direto, a quantidade.
    estadoTons(motivo) {
      if (!this.quadroPronto()) return null;
      var o = this.oferta;
      var snap = o.snapshotSelected() || {};
      var s = { tons: true, rotulo: this.rotuloVariante(), motivo: motivo === undefined ? this.motivo() : motivo, qtd: 1, unidades: [], rotuloDegrau: '', nome: this.nomeCurto(), thumb: this.thumbBarra() };
      if ('direct' in snap) {
        s.qtd = Math.max(1, parseInt(snap.qty, 10) || 1);
        s.unidades.push(unidadeDe(o.querySelector('.pdp-offer__swatches'), snap.direct));
        return s;
      }
      var tier = typeof o.getCheckedTier === 'function' ? o.getCheckedTier() : null;
      if (!tier) return s;
      var rotulo = tier.querySelector('.pdp-offer__tier-name');
      s.rotuloDegrau = rotuloDaBarra(tier) || (rotulo ? String(rotulo.textContent || '').trim() : '');
      var unidades = tier.querySelectorAll('.pdp-offer__unit');
      var ids = snap.units || [];
      for (var i = 0; i < ids.length; i++) {
        s.unidades.push(unidadeDe(unidades[i], ids[i]));
      }
      return s;
    }

    // Um redesenho por quadro de animação (microtarefa sem requestAnimationFrame), só na oferta com tons.
    agendarRedesenho() {
      if (this.ligado === false || this.redesenhoAgendado || !this.ofertaComTons()) return;
      this.redesenhoAgendado = true;
      var self = this;
      var rodar = function () {
        if (!self.redesenhoAgendado) return;
        self.redesenhoAgendado = false;
        self.quadroRedesenho = 0;
        self.redesenhar();
      };
      if (typeof window.requestAnimationFrame === 'function') this.quadroRedesenho = window.requestAnimationFrame(rodar);
      else Promise.resolve().then(rodar);
    }

    // Barra com tons: reescreve o lado esquerdo e o botão pelo estado do quadro, espelha o preço, reavalia se
    // aparece e marca com data-pdp-tom-foco o controle que recebe o foco quando a gaveta (ou o finder do Trio, que
    // lê o mesmo atributo) fecha: o botão; com a combinação completa e indisponível, o "Trocar o tom", por onde se
    // corrige (o botão apagado só reabriria a gaveta). Sem tons ou com o quadro por inicializar, nenhuma escrita na
    // barra: só o preço e a visibilidade, como antes.
    redesenhar() {
      var tons = !!this.barra && this.ofertaComTons() && this.quadroPronto();
      var r = tons ? rotuloBarra(this.estadoTons()) : null;
      if (r) this.escreverBarra(r);
      this.espelharPreco();
      this.atualizar();
      var botao = r && this.barraTom ? this.barra.querySelector('[data-pdp-cta-botao]') : null;
      if (botao) {
        var trocar = this.barraTom.querySelector('[data-pdp-tom-abrir]');
        var foco = r.botao.desabilitado && trocar ? trocar : botao;
        if (trocar && trocar !== foco) trocar.removeAttribute('data-pdp-tom-foco');
        if (botao !== foco) botao.removeAttribute('data-pdp-tom-foco');
        foco.setAttribute('data-pdp-tom-foco', '');
      }
      if (this.tomAberta) this.desenharGaveta();
    }

    // O .pdp-cta__barra-info ganha, na primeira reescrita, dois filhos fixos: .pdp-cta__barra-tom (o lado esquerdo
    // do rotuloBarra) e o .pdp-cta__barra-preco do template (alvo do espelharPreco), movido para fora da miniatura
    // quando houver. Depois disso só o conteúdo do primeiro e o botão mudam, e só quando mudam (o foco no
    // "Trocar o tom" sobrevive a um redesenho igual).
    escreverBarra(r) {
      var info = this.barra.querySelector('.pdp-cta__barra-info');
      var botao = this.barra.querySelector('[data-pdp-cta-botao]');
      if (!info || !botao) return;
      if (!this.barraTom) {
        this.nomeCurto();
        this.thumbBarra();
        var preco = info.querySelector('.pdp-cta__barra-preco');
        if (!preco) {
          preco = document.createElement('span');
          preco.className = 'pdp-cta__barra-preco';
        }
        this.barraTom = document.createElement('span');
        this.barraTom.className = 'pdp-cta__barra-tom';
        info.replaceChildren(this.barraTom, preco);
        this.barra.classList.add('pdp-cta__barra--tons');
      }
      if (this.barraTomHtml !== r.esquerda) {
        this.barraTom.innerHTML = r.esquerda;
        this.barraTomHtml = r.esquerda;
      }
      var b = r.botao;
      if (botao.textContent !== b.texto) botao.textContent = b.texto;
      botao.classList.toggle('pdp-cta__botao--tom', b.classe === 'pdp-cta__botao--tom');
      botao.classList.toggle('pdp-cta__botao--comprar', b.classe === 'pdp-cta__botao--comprar');
      if (b.desabilitado) botao.setAttribute('aria-disabled', 'true');
      else botao.removeAttribute('aria-disabled');
    }

    // ---- Gaveta de tom (spec 2026-10-27-barra-tom 4.2 a 4.4) ----
    // Um <dialog> nativo no body (iOS, como a barra), montado uma vez na oferta com tons e escondido até a barra
    // abri-lo. A folha (.pdp-tom__folha) é a superfície: tudo fica dentro dela, e o ::backdrop fica fora. Sem a barra
    // (barra_fixa desligado, data-barra="off"), nada a abriria: nem o dialog nem o ouvinte de resize.
    montarGaveta() {
      if (this.gavetaTom || !this.barra || !this.ofertaComTons()) return;
      var self = this;
      var vg = vocab(this.rotuloVariante());
      var d = criar('dialog', { class: 'pdp-tom', 'data-pdp-tom': '', 'aria-labelledby': 'pdp-tom-titulo' });
      // Sem <dialog> nativo (Safari antes de 15.4) não há top layer, véu, foco preso nem Esc: a gaveta não é montada e a
      // barra leva ao quadro, como antes dela (abrirGaveta).
      if (typeof d.showModal !== 'function') return;
      var folha = criar('div', { class: 'pdp-tom__folha' });
      var cabeca = criar('div', { class: 'pdp-tom__cabeca' });
      var fechar = criar('button', { type: 'button', class: 'pdp-tom__fechar', 'data-pdp-tom-fechar': '', 'aria-label': 'Fechar' }, '×');
      cabeca.appendChild(criar('h2', { class: 'pdp-tom__titulo', id: 'pdp-tom-titulo' }, 'Qual é ' + (vg.nome === 'cor' ? 'a ' : 'o ') + vg.seu + '?'));
      cabeca.appendChild(fechar);
      var degraus = criar('div', { class: 'pdp-tom__degraus', role: 'radiogroup', 'aria-label': 'Quantidade' });
      degraus.hidden = true;
      var unidades = criar('div', { class: 'pdp-tom__unidades' });
      // Região viva sempre no DOM e vazia; o texto entra e sai (desenharGaveta). Uma região escondida que passa a ser
      // mostrada é anunciada de forma irregular (o VoiceOver do iPhone costuma não ler).
      var aviso = criar('p', { class: 'pdp-tom__aviso', role: 'status' });
      var rodape = criar('div', { class: 'pdp-tom__rodape' });
      var preco = criar('span', { class: 'pdp-tom__preco' });
      var comprar = criar('button', { type: 'button', class: 'pdp-tom__comprar', 'data-pdp-cta-botao': '', 'data-origem': 'gaveta' }, 'Comprar agora');
      rodape.appendChild(preco);
      rodape.appendChild(comprar);
      // Com cor, o link abre a gaveta de cor (assets/biobio-pdp-guia-cor.js). O ignore-scroll tira o link do rolar suave
      // do theme.js (a[href^="#"]), que correria a página até o quadro por trás da gaveta de cor.
      var ajuda = vg.nome === 'cor'
        ? criar('a', { class: 'pdp-tom__ajuda ignore-scroll', href: '#pdp-oferta', 'data-pdp-guia-trigger': '', 'data-pdp-tom-origem': 'barra' }, 'Me ajuda a escolher')
        : criar('a', { class: 'pdp-tom__ajuda', href: '/pages/encontre-seu-tom', 'data-trio-finder-trigger': '', 'data-pdp-tom-origem': 'barra' }, 'Me ajuda a escolher');
      [criar('div', { class: 'pdp-tom__alca', 'aria-hidden': 'true' }), cabeca, degraus, unidades, aviso, rodape, ajuda].forEach(function (f) { folha.appendChild(f); });
      d.appendChild(folha);

      fechar.addEventListener('click', function () { self.fecharGaveta(); });
      // Esc: o cancel fecha pelo mesmo caminho do ×. O close cobre o fechamento nativo sem cancel; ele chega numa
      // tarefa à parte, então só vale enquanto este dialog é o montado (não o de antes de uma remontagem) e continua
      // fechado (um close atrasado não desfaz uma reabertura).
      d.addEventListener('cancel', function (e) {
        e.preventDefault();
        self.fecharGaveta();
      });
      d.addEventListener('close', function () { if (self.gavetaTom === d && !d.open) self.aoFecharGaveta(); });
      // Toque no véu: o clique no ::backdrop chega no próprio dialog, nunca num filho (a folha cobre o resto).
      d.addEventListener('click', function (e) { if (e.target === d) self.fecharGaveta(); });
      degraus.addEventListener('change', function (e) {
        var r = e.target;
        if (r && r.getAttribute && r.getAttribute('name') === 'pdp-tom-degrau') self.trocarDegrau(r);
      });
      // Bolinhas: o clique (toque) e o change do rádio (setas do teclado), os dois pela mesma rotina do quadro, que
      // ignora a bolinha já marcada. A riscada (classe ou rádio desabilitado) não passa daqui: o VariantPickerSwatches
      // do assets/theme.js escuta o click de qualquer .swatch no document e marcaria o rádio desabilitado, tirando a
      // marca do tom escolhido.
      var aoBolinha = function (e) {
        var sw = e.target && e.target.closest ? e.target.closest('label.swatch') : null;
        if (!sw) return;
        var r = sw.querySelector('input');
        if (sw.classList.contains('swatch--disabled') || (r && r.disabled)) {
          e.preventDefault();
          e.stopPropagation();
        }
        self.escolherBolinha(sw);
      };
      unidades.addEventListener('click', aoBolinha);
      unidades.addEventListener('change', aoBolinha);
      comprar.addEventListener('click', function () { self.comprar('gaveta'); });
      // "Me ajuda a escolher": fecha esta gaveta sem mexer no foco e deixa o clique seguir até a guarda do Trio (tom) ou
      // até a gaveta de cor (cor), que escutam no document e abrem com este link de gatilho.
      ajuda.addEventListener('click', function () { self.fecharGaveta({ foco: false }); }, true);
      this.aoRedimensionarTom = function () {
        if (self.tomAberta && window.innerWidth >= 1024) self.fecharGaveta();
      };
      window.addEventListener('resize', this.aoRedimensionarTom);
      // Pedido do finder do Trio aberto pelo "Me ajuda a escolher" (assets/biobio-trio.js), ao aplicar um tom e ao
      // fechar: o clique dele no label do quadro agendou um redesenho que recria o "Trocar o tom", então o foco sai
      // pelo devolverFoco, que assenta o redesenho antes de escolher o alvo. O preventDefault avisa o finder.
      this.aoPedirFoco = function (e) {
        self.devolverFoco(null);
        e.preventDefault();
      };
      document.addEventListener('pdp-tom:devolver-foco', this.aoPedirFoco);
      document.body.appendChild(d);
      this.gavetaTom = d;
      this.tom = { folha: folha, degraus: degraus, unidades: unidades, aviso: aviso, preco: preco, comprar: comprar };
      this.tomPrecoHtml = null;
      this.tomGrupos = null;
    }

    // Idempotente: fecha a gaveta aberta sem foco (sai o touchmove e as classes que ela pôs), cancela o redesenho
    // pendente, tira o dialog do body, o ouvinte de resize e o do pedido de foco do finder. O connectedCallback
    // seguinte monta tudo de novo.
    desmontarGaveta() {
      if (this.tomAberta) this.fecharGaveta({ foco: false });
      if (this.quadroRedesenho && typeof window.cancelAnimationFrame === 'function') window.cancelAnimationFrame(this.quadroRedesenho);
      this.quadroRedesenho = 0;
      this.redesenhoAgendado = false;
      if (this.aoRedimensionarTom) window.removeEventListener('resize', this.aoRedimensionarTom);
      if (this.aoPedirFoco) document.removeEventListener('pdp-tom:devolver-foco', this.aoPedirFoco);
      if (this.gavetaTom && this.gavetaTom.parentNode) this.gavetaTom.parentNode.removeChild(this.gavetaTom);
      this.gavetaTom = this.tom = this.aoRedimensionarTom = this.aoPedirFoco = this.tomGrupos = null;
    }

    // Abre pela barra ("Escolha seu tom", "Trocar o tom" ou o "Comprar agora" apagado). Já aberta, só redesenha.
    abrirGaveta() {
      var d = this.gavetaTom;
      if (!this.quadroPronto()) return;
      if (!d) {
        // Gaveta não montada com a barra à mostra (navegador sem <dialog> nativo): o quadro escolhe o tom. Sem barra
        // (barra_fixa desligado), nada.
        if (this.barra && this.oferta) {
          this.oferta.scrollIntoView({ behavior: reduzMovimento() ? 'auto' : 'smooth', block: 'center' });
          this.focarOferta();
        }
        return;
      }
      if (this.tomAberta) {
        this.desenharGaveta();
        return;
      }
      this.tomGrupos = null; // as bolinhas são clonadas de novo a cada abertura
      this.desenharGaveta();
      this.tomAberta = true;
      this.tomFoco = true;
      d.classList.add('pdp-tom--entrando', 'pdp-tom--aberta');
      d.showModal();
      // Subida: a folha nasce embaixo (pdp-tom--entrando); lido o layout, a classe sai e a transição do CSS a sobe.
      void this.tom.folha.offsetHeight;
      d.classList.remove('pdp-tom--entrando');
      this.travarRolagem();
      this.focarGaveta();
    }

    // Trava de rolagem igual à da gaveta do Trio (assets/biobio-trio.js, lockScroll e touchGuard): a classe em html
    // e body e, no iOS, quem segura a página de fato, o touchmove fora da folha cancelado. Um toque no ::backdrop
    // tem o próprio dialog como alvo, fora da folha. Dentro da folha o arrasto também é cancelado quando ela cabe
    // inteira e não rola: no iPhone ele encadearia para a página. Só as classes que ela pôs saem no fechamento.
    travarRolagem() {
      var folha = this.tom.folha;
      this.tomTravas = [document.documentElement, document.body].filter(function (el) {
        if (el.classList.contains(SEM_ROLAGEM)) return false;
        el.classList.add(SEM_ROLAGEM);
        return true;
      });
      this.guardaToque = function (e) {
        if (!folha.contains(e.target) || folha.scrollHeight <= folha.clientHeight) e.preventDefault();
      };
      document.addEventListener('touchmove', this.guardaToque, { passive: false });
    }

    // Foco ao abrir: o primeiro rádio marcado (a pílula do degrau, ou a bolinha escolhida), senão a primeira bolinha
    // habilitada.
    focarGaveta() {
      var radios = Array.prototype.slice.call(this.gavetaTom.querySelectorAll('input[type="radio"]'));
      var alvo = radios.filter(function (r) { return r.checked && !r.disabled; })[0] ||
        radios.filter(function (r) { return !r.disabled && r.getAttribute('name') !== 'pdp-tom-degrau'; })[0];
      if (alvo) alvo.focus({ preventScroll: true });
    }

    // Fecha pelo ×, pelo Esc, pelo véu, pela largura de desktop, pela compra, pelo carrinho por cima ou pelo link do
    // finder. { foco: false } não devolve o foco (o carrinho ou o finder cuidam dele).
    fecharGaveta(opcoes) {
      if (!this.tomAberta) return;
      this.tomFoco = !(opcoes && opcoes.foco === false);
      var d = this.gavetaTom;
      if (typeof d.close === 'function') d.close();
      if (d.hasAttribute('open')) d.removeAttribute('open');
      this.aoFecharGaveta();
    }

    // Destrava a página e repõe a rolagem (rede de segurança, como no Trio); com foco, devolve-o à barra. A rolagem
    // de referência é a lida logo antes de destravar, não a da abertura (Ruling R2): com a gaveta aberta, o scroll
    // anchoring do Chrome ajusta o scrollY quando o quadro acima da tela muda de altura (Leve 3 para Leve 1), e
    // voltar ao valor da abertura faria a página saltar. Só um salto do próprio destravamento é desfeito.
    aoFecharGaveta() {
      if (!this.tomAberta) return;
      this.tomAberta = false;
      var foco = this.tomFoco !== false;
      this.tomFoco = true;
      var abridor = this.abridorTom;
      this.abridorTom = null;
      var rolagem = window.scrollY || window.pageYOffset || 0;
      this.gavetaTom.classList.remove('pdp-tom--aberta', 'pdp-tom--entrando');
      (this.tomTravas || []).forEach(function (el) { el.classList.remove(SEM_ROLAGEM); });
      this.tomTravas = [];
      if (this.guardaToque) document.removeEventListener('touchmove', this.guardaToque, { passive: false });
      this.guardaToque = null;
      if (Math.abs((window.scrollY || window.pageYOffset || 0) - rolagem) > 1) window.scrollTo(0, rolagem);
      if (foco) this.devolverFoco(abridor);
    }

    // Foco de volta ao controle da barra que abriu a gaveta, sem rolar (spec 4.2). O redesenho pendente roda antes:
    // a barra assentada decide o que está à mostra. Aberta pelo "Trocar o tom" (abridor 'trocar'), o "Trocar o tom"
    // atual (o redesenho pode tê-lo recriado); senão, ou sem ele à mostra, o data-pdp-tom-foco (o botão, ou o "Trocar
    // o tom" com a combinação indisponível). Escondido ou ausente (ex. a largura de desktop esconde a barra), vai
    // para o involucro da PDP, focável só enquanto tiver o foco (tabindex -1 que sai no blur).
    devolverFoco(abridor) {
      if (this.redesenhoAgendado) {
        if (this.quadroRedesenho && typeof window.cancelAnimationFrame === 'function') window.cancelAnimationFrame(this.quadroRedesenho);
        this.quadroRedesenho = 0;
        this.redesenhoAgendado = false;
      }
      this.redesenhar();
      var alvo = null;
      if (this.barra) {
        var trocar = abridor === 'trocar' ? this.barra.querySelector('[data-pdp-tom-abrir]') : null;
        alvo = trocar && trocar.offsetParent !== null ? trocar : this.barra.querySelector('[data-pdp-tom-foco]');
      }
      var tirarTabindex = null;
      if (!alvo || alvo.offsetParent === null) {
        alvo = (this.oferta && this.oferta.closest('.product-details')) || document.querySelector('.product-details');
        if (!alvo) return;
        // Só o tabindex posto aqui sai (no blur, ou na hora se o foco não pegar); o que já era da reserva fica.
        if (!alvo.hasAttribute('tabindex')) {
          var involucro = alvo;
          tirarTabindex = function () {
            involucro.removeAttribute('tabindex');
            involucro.removeEventListener('blur', tirarTabindex);
          };
          involucro.setAttribute('tabindex', '-1');
          involucro.addEventListener('blur', tirarTabindex);
        }
      }
      alvo.focus({ preventScroll: true });
      // Foco que não pegou na reserva (ancestral inert, elemento sem caixa): o blur nunca viria, limpa na hora.
      if (tirarTabindex && document.activeElement !== alvo) tirarTabindex();
    }

    // Desenho da gaveta pelo quadro assentado: pílulas, fileiras, preço e o botão do rodapé, que espelha o motivo
    // do quadro (sem tom: "Escolha o tom"; indisponível ou esgotado: o aviso; qualquer trava: apagado).
    desenharGaveta() {
      if (!this.gavetaTom || !this.quadroPronto()) return;
      var cards = Array.prototype.slice.call(this.oferta.querySelectorAll('.pdp-offer__tier'));
      this.desenharDegraus(cards);
      this.desenharUnidades(cards.length > 0);
      var preco = precoGaveta({ total: this.totalOferta ? this.totalOferta.textContent : '', de: this.deOferta() });
      if (this.tomPrecoHtml !== preco) {
        this.tom.preco.innerHTML = preco;
        this.tomPrecoHtml = preco;
      }
      var m = this.motivo();
      var b = this.tom.comprar;
      var texto = m === 'sem-tom' ? 'Escolha ' + vocab(this.rotuloVariante()).o : 'Comprar agora';
      if (b.textContent !== texto) b.textContent = texto;
      b.disabled = m !== null;
      var aviso = m === 'indisponivel' || m === 'esgotado' ? avisoTom(vocab(this.rotuloVariante())) : '';
      if (this.tom.aviso.textContent !== aviso) this.tom.aviso.textContent = aviso;
    }

    // Uma pílula por degrau do quadro (só com 2 ou mais): o rótulo ("Leve 3 · pague 2"), o preço que o quadro escreve
    // no card (com o "R$" preso ao número) e o marcado e o indisponível do quadro.
    desenharDegraus(cards) {
      var box = this.tom.degraus;
      if (cards.length < 2) {
        box.hidden = true;
        if (box.children.length) box.replaceChildren();
        return;
      }
      box.hidden = false;
      if (box.children.length !== cards.length) {
        box.replaceChildren();
        cards.forEach(function (card) {
          var desc = textoDe(card.querySelector('.pdp-offer__tier-desc'));
          var label = criar('label', { class: 'pdp-tom__degrau' });
          label.appendChild(criar('input', { type: 'radio', name: 'pdp-tom-degrau', value: card.getAttribute('data-tier') || '' }));
          label.appendChild(criar('span', { class: 'pdp-tom__degrau-rotulo' }, rotuloDaBarra(card) || (textoDe(card.querySelector('.pdp-offer__tier-name')) + (desc ? ' · ' + desc : ''))));
          label.appendChild(criar('span', { class: 'pdp-tom__degrau-preco' }));
          box.appendChild(label);
        });
      }
      cards.forEach(function (card, i) {
        var label = box.children[i];
        var input = label.querySelector('input');
        var radio = card.querySelector('input[name="pdp-tier"]');
        input.checked = !!(radio && radio.checked);
        input.disabled = card.getAttribute('data-tier-indisponivel') === '1';
        var origem = card.querySelector('.pdp-offer__tier-price');
        var html = origem ? origem.innerHTML.split('R$ ').join('R$&nbsp;') : '';
        var alvo = label.querySelector('.pdp-tom__degrau-preco');
        if (alvo.innerHTML !== html) alvo.innerHTML = html;
        // Nome acessível do rádio (o visual não muda): o rótulo e o preço lido como "De R$ X por R$ Y", como o
        // rodapé; o conteúdo da pílula leria o riscado sem o "De".
        var por = textoDe(card.querySelector('[data-tier-now]'));
        var deEl = card.querySelector('[data-tier-compare]');
        var de = deEl && !deEl.hidden ? textoDe(deEl) : '';
        var nome = label.querySelector('.pdp-tom__degrau-rotulo').textContent + (por ? ', ' + (de ? 'De ' + de + ' por ' + por : por) : '');
        if (input.getAttribute('aria-label') !== nome) input.setAttribute('aria-label', nome);
      });
    }

    // Fileiras de bolinhas do quadro, na ordem das unidades do degrau marcado (com o rótulo de cada uma); no modo
    // direto (comCards falso), a única.
    fileirasQuadro(comCards) {
      var o = this.oferta;
      if (!comCards) {
        var unica = o.querySelector('.pdp-offer__swatches');
        return unica ? [{ grupo: unica, rotulo: null, desc: o.querySelector('[data-unit-desc]') }] : [];
      }
      var tier = typeof o.getCheckedTier === 'function' ? o.getCheckedTier() : null;
      var out = [];
      if (!tier) return out;
      Array.prototype.forEach.call(tier.querySelectorAll('.pdp-offer__unit'), function (u) {
        var g = u.querySelector('.pdp-offer__swatches');
        if (g) out.push({ grupo: g, rotulo: u.querySelector('.pdp-offer__current'), desc: u.querySelector('[data-unit-desc]') });
      });
      return out;
    }

    // Uma fileira por unidade, com as bolinhas clonadas do quadro: as mesmas que ele imprimiu (a oculta nem existe),
    // com o estilo, a esgotada riscada e a marcada; os rádios ganham nome e id próprios. No mesmo degrau, só o estado
    // e o rótulo mudam (o foco numa bolinha sobrevive ao redesenho); degrau novo, fileiras novas.
    desenharUnidades(comCards) {
      var fileiras = this.fileirasQuadro(comCards);
      var grupos = fileiras.map(function (f) { return f.grupo; });
      var vg = vocab(this.rotuloVariante());
      var box = this.tom.unidades;
      var antes = this.tomGrupos;
      var mesmo = !!antes && antes.length === grupos.length && grupos.every(function (g, i) { return g === antes[i]; });
      if (!mesmo) {
        box.replaceChildren();
        fileiras.forEach(function (f, i) {
          var n = i + 1;
          var unidade = criar('div', { class: 'pdp-tom__unidade' });
          unidade.appendChild(criar('p', { class: 'pdp-tom__unidade-rotulo' }));
          var fila = criar('div', { class: 'swatches pdp-tom__swatches', role: 'radiogroup', 'aria-label': f.grupo.getAttribute('aria-label') || 'Escolha o tom' });
          Array.prototype.forEach.call(f.grupo.querySelectorAll('label.swatch'), function (sw, j) {
            var c = sw.cloneNode(true);
            var r = c.querySelector('input');
            if (r) {
              r.setAttribute('name', 'pdp-tom-u' + n);
              r.setAttribute('id', 'pdp-tom-u' + n + '-' + (j + 1));
            }
            fila.appendChild(c);
          });
          unidade.appendChild(fila);
          // Descrição da cor (custom.descricao_cor) sob a fileira; só existe quando o quadro a imprimiu (a Base não).
          if (f.desc) unidade.appendChild(criar('p', { class: 'pdp-tom__cor-desc', hidden: '' }));
          box.appendChild(unidade);
        });
        this.tomGrupos = grupos;
      }
      var snap = this.oferta.snapshotSelected() || {};
      fileiras.forEach(function (f, i) {
        var unidade = box.children[i];
        // Rótulo do quadro ("1ª unidade · #300 Castanha", "Escolha o tom"); no modo direto, o tom da variante.
        var rotulo = f.rotulo ? textoDe(f.rotulo) : ((unidadeDe(f.grupo, snap.direct) || {}).nome || 'Escolha ' + vg.o);
        var p = unidade.querySelector('.pdp-tom__unidade-rotulo');
        if (p.textContent !== rotulo) p.textContent = rotulo;
        var desc = unidade.querySelector('.pdp-tom__cor-desc');
        if (desc && f.desc) {
          var dt = f.desc.hidden ? '' : textoDe(f.desc);
          if (desc.textContent !== dt) desc.textContent = dt;
          desc.hidden = !dt;
        }
        var origens = f.grupo.querySelectorAll('label.swatch');
        Array.prototype.forEach.call(unidade.querySelectorAll('label.swatch'), function (c, j) {
          var q = origens[j];
          if (!q) return;
          var qi = q.querySelector('input');
          var ci = c.querySelector('input');
          c.classList.toggle('swatch--selected', q.classList.contains('swatch--selected'));
          c.classList.toggle('swatch--disabled', q.classList.contains('swatch--disabled'));
          if (ci && qi) {
            ci.disabled = !!qi.disabled;
            ci.checked = !!qi.checked;
          }
        });
      });
    }

    // Bolinha da gaveta: a bolinha da mesma variante na mesma unidade do quadro, pela rotina dele (onSwatch).
    // A bolinha recusada também agenda o redesenho: o estado da gaveta volta ao do quadro.
    escolherBolinha(sw) {
      var r = sw.querySelector('input');
      if (r && !r.disabled && !sw.classList.contains('swatch--disabled') && this.quadroPronto()) {
        var i = Array.prototype.indexOf.call(this.tom.unidades.children, sw.closest('.pdp-tom__unidade'));
        var f = this.fileirasQuadro(!!this.oferta.querySelector('.pdp-offer__tier'))[i];
        var par = f ? f.grupo.querySelector('.swatch[data-variant-id="' + Number(sw.getAttribute('data-variant-id')) + '"]') : null;
        if (par) this.oferta.onSwatch(par);
      }
      this.agendarRedesenho();
    }

    // Pílula de degrau: clica o mesmo rádio no quadro (a rotina de troca é a dele). Se a 1ª unidade do degrau novo
    // está vazia e a do anterior tinha tom, ela herda esse tom pelo onSwatch do quadro, para a escolha não sumir em
    // silêncio; as outras unidades ficam por escolher. Sem o rádio no quadro, só o redesenho (a pílula volta a ele).
    trocarDegrau(r) {
      var o = this.oferta;
      var valor = r.getAttribute('value');
      var alvo = null;
      if (this.quadroPronto()) {
        Array.prototype.forEach.call(o.querySelectorAll('input[name="pdp-tier"]'), function (x) {
          if (x.getAttribute('value') === valor) alvo = x;
        });
      }
      if (!alvo) {
        this.agendarRedesenho();
        return;
      }
      var antes = (o.snapshotSelected() || {}).units;
      var tomAntes = antes && antes.length ? antes[0] : null;
      if (!alvo.checked) alvo.click();
      var depois = (o.snapshotSelected() || {}).units;
      if (tomAntes != null && depois && depois.length && depois[0] == null) {
        var tier = o.getCheckedTier();
        var u = tier ? tier.querySelector('.pdp-offer__unit') : null;
        var sw = u ? u.querySelector('.swatch[data-variant-id="' + Number(tomAntes) + '"]') : null;
        if (sw) o.onSwatch(sw);
      }
      this.agendarRedesenho();
    }

    ofertaBloqueada() {
      if (!this.botaoOferta) return true;
      if (this.botaoOferta.disabled) return true;
      if (this.botaoOferta.getAttribute('aria-disabled') === 'true') return true;
      return this.botaoOferta.offsetParent === null; // escondido (ex. avise-me no lugar do botao)
    }

    montarBarra() {
      if (this.dataset.barra === 'off' || !this.oferta) return;
      var tpl = this.querySelector('template[data-pdp-cta-barra]');
      if (!tpl || !tpl.content || !tpl.content.firstElementChild) return;
      this.barra = tpl.content.firstElementChild.cloneNode(true);
      this.barra.hidden = true;
      if (this.temLayout()) this.agruparProdutoBarra();
      var botao = this.barra.querySelector('[data-pdp-cta-botao]');
      if (botao) botao.addEventListener('click', this.comprar.bind(this, 'barra'));
      var self = this;
      // "Trocar o tom" da barra com tons: reescrito por innerHTML a cada estado, então por delegação. O ouvinte guarda
      // o tipo do controle que abriu a gaveta, 'trocar' ou 'botao' (o principal, cujo clique chega aqui depois do
      // comprar dele, que já a abriu), para o foco voltar a ele ao fechar.
      if (this.ofertaComTons()) {
        this.barra.addEventListener('click', function (event) {
          var alvo = event.target && event.target.closest ? event.target : null;
          if (!alvo) return;
          if (alvo.closest('[data-pdp-tom-abrir]')) {
            self.abridorTom = 'trocar';
            self.abrirGaveta('barra');
          } else if (alvo.closest('[data-pdp-cta-botao]')) {
            self.abridorTom = 'botao';
          }
        });
      }
      document.body.appendChild(this.barra);
      this.ofertaVisivel = true;
      if ('IntersectionObserver' in window) {
        this.io = new IntersectionObserver(function (entradas) {
          // R76: a oferta ainda ABAIXO da tela conta como visível. A barra só aparece depois de
          // passar pela oferta ("quando o quadro de compra sai da tela"), nunca na primeira tela
          // de quem ainda não chegou nela.
          var e = entradas[entradas.length - 1];
          self.ofertaVisivel = ofertaNaoPassou(e);
          self.atualizar();
        }, { threshold: 0 });
        this.io.observe(this.oferta);
      }
      // O IntersectionObserver só avisa quando a oferta cruza a tela. Um salto de rolagem que vai
      // de antes dela para depois dela (âncora, scrollTo, voltar ao topo) não cruza nada e não
      // gera aviso; a rolagem, um quadro por vez, reavalia pela posição.
      this.aoRolar = function () {
        if (self.quadroRolagem) return;
        self.quadroRolagem = window.requestAnimationFrame(function () {
          self.quadroRolagem = 0;
          if (!self.oferta) return;
          var antes = self.ofertaVisivel;
          self.ofertaVisivel = ofertaNaoPassou({ boundingClientRect: self.oferta.getBoundingClientRect() });
          if (antes !== self.ofertaVisivel) self.atualizar();
        });
      };
      window.addEventListener('scroll', this.aoRolar, { passive: true });
      // Trava fora da tela (R60): o botão da oferta trava ou destrava (esgotou, avise-me no
      // lugar, tom por escolher) sem a oferta cruzar a tela; a barra se reavalia como no
      // IntersectionObserver.
      if (this.botaoOferta) {
        this.moTrava = new MutationObserver(function () { self.atualizar(); self.agendarRedesenho(); });
        this.moTrava.observe(this.botaoOferta, { attributes: true, attributeFilter: ['disabled', 'aria-disabled', 'hidden', 'style', 'class'] });
      }
      // Carrinho por cima (show-cart-summary, pela compra da gaveta ou por um add de fora): a gaveta de tom fecha
      // sem foco e não volta sozinha quando o carrinho fecha.
      this.mo = new MutationObserver(function () {
        self.atualizar();
        if (self.tomAberta && gavetaAberta()) self.fecharGaveta({ foco: false });
      });
      this.mo.observe(document.documentElement, { attributes: true, attributeFilter: ['class'] });
      this.mo.observe(document.body, { attributes: true, attributeFilter: ['class'] });
      this.aoRedimensionar = function () { self.atualizar(); };
      window.addEventListener('resize', this.aoRedimensionar);
      this.atualizar();
    }

    ligarPreco() {
      this.totalOferta = this.oferta.querySelector('[data-pdp-total]');
      if (!this.totalOferta) return;
      var self = this;
      this.moPreco = new MutationObserver(function () { self.espelharPreco(); self.agendarRedesenho(); });
      this.moPreco.observe(this.totalOferta, { childList: true, characterData: true, subtree: true });
      // P7: na oferta com tons o "de" também é espelhado. O total é regravado a cada escolha (o mesmo
      // updateSummary que mexe no "de"), então o observador dele já basta; este cobre o "de" sozinho.
      if (this.ofertaComTons() || this.ofertaR2()) {
        this.compareOferta = this.oferta.querySelector('[data-pdp-compare]');
        if (this.compareOferta) this.moPreco.observe(this.compareOferta, { childList: true, characterData: true, subtree: true, attributes: true, attributeFilter: ['hidden'] });
      }
      this.espelharPreco();
    }

    // Oferta com o layout novo da família (pdp-offer--layout: a Base e o BBS com tons, o Pó sem eles).
    temLayout() {
      return !!(this.oferta && this.oferta.classList && this.oferta.classList.contains('pdp-offer--layout'));
    }

    // Barra com layout: miniatura e nome num .pdp-cta__barra-produto (nome em negrito, sem corte), o preço fora dele
    // no .pdp-cta__barra-info. Sem miniatura no template, só a classe. Com tons, a primeira reescrita (escreverBarra)
    // troca o conteúdo do info como sempre e lê a miniatura do cache antes disso.
    agruparProdutoBarra() {
      this.barra.classList.add('pdp-cta__barra--layout');
      var info = this.barra.querySelector('.pdp-cta__barra-info');
      var thumb = this.barra.querySelector('.pdp-cta__thumb--barra');
      var nome = this.barra.querySelector('.pdp-cta__barra-nome');
      if (!info || !thumb || !nome) return;
      this.thumbBarra();
      var preco = info.querySelector('.pdp-cta__barra-preco');
      var produto = document.createElement('span');
      produto.className = 'pdp-cta__barra-produto';
      produto.appendChild(thumb);
      produto.appendChild(nome);
      if (preco) info.replaceChildren(produto, preco);
      else info.replaceChildren(produto);
    }

    ofertaComTons() {
      return !!(this.oferta && this.oferta.classList && this.oferta.classList.contains('pdp-offer--tons'));
    }

    ofertaR2() {
      return !!(this.oferta && this.oferta.classList && this.oferta.classList.contains('pdp-offer--r2'));
    }

    // Tom escolhido em todas as unidades do degrau marcado: o isComplete() do próprio <pdp-offer>. Com a oferta
    // ainda sem o método (script dela por carregar), vale o texto do botão: "Escolha o tom" é sem tom.
    ofertaCompleta() {
      if (this.oferta && typeof this.oferta.isComplete === 'function') return !!this.oferta.isComplete();
      var b = this.botaoOferta;
      if (!b || !b.dataset || !b.dataset.textIncomplete) return true;
      return String(b.textContent || '').trim() !== b.dataset.textIncomplete;
    }

    deOferta() {
      var c = this.compareOferta;
      return c && !c.hidden ? String(c.textContent || '').trim() : '';
    }

    espelharPreco() {
      var total = this.totalOferta ? this.totalOferta.textContent.trim() : '';
      var tons = this.ofertaComTons();
      var r2 = this.ofertaR2();
      var completo = tons ? this.ofertaCompleta() : true;
      var r = precoCta({ rotulo: this.rotuloVariante(), tons: tons, r2: r2, completo: completo, total: total, de: tons || r2 ? this.deOferta() : '' });
      var alvos = Array.from(this.querySelectorAll('.pdp-cta__preco'));
      var alvosBarra = this.barra ? Array.from(this.barra.querySelectorAll('.pdp-cta__barra-preco')) : [];
      // Barra já redesenhada com tons: sem tom, o preço fica vazio (o CSS o esconde) e o convite está no botão.
      var rBarra = this.barraTom && tons && !completo ? { html: '' } : r;
      alvos.forEach(escreverPreco(r));
      alvosBarra.forEach(escreverPreco(rBarra));
    }

    atualizar() {
      if (!this.barra) return;
      var bloqueada = this.ofertaBloqueada();
      var comBloqueio = false;
      if (this.ofertaComTons()) {
        // Com tons, o motivo manda: sem tom e indisponível mostram a barra; o quadro por inicializar, o esgotado,
        // o degrau indisponível e a compra em andamento escondem.
        var m = this.motivo();
        if (m !== null) bloqueada = true;
        comBloqueio = m === 'sem-tom' || m === 'indisponivel';
      }
      var mostrar = estadoBarra({
        ligada: this.dataset.barra !== 'off',
        largura: window.innerWidth,
        ofertaVisivel: this.ofertaVisivel,
        gavetaAberta: gavetaAberta(),
        carrinhoAtualizando: carrinhoAtualizando(),
        ofertaBloqueada: bloqueada,
        mostraComBloqueio: comBloqueio,
      });
      if (mostrar === !this.barra.hidden) return;
      this.barra.hidden = !mostrar;
      document.body.classList.toggle('pdp-cta-barra-visivel', mostrar);
    }

    // Foco no quadro de compra, depois de rolar até ele: quem usa teclado ou leitor de tela não
    // fica no botão repetido, fora da tela. Vai para o avise-me, se estiver à mostra; senão para
    // o botão da oferta, se aceitar foco (aria-disabled aceita, disabled não); senão para a
    // própria oferta, focável só enquanto tiver o foco (tabindex -1 que sai no blur).
    focarOferta() {
      var alvos = [this.oferta.querySelector('[data-pdp-avise-open]'), this.botaoOferta];
      var alvo = null;
      for (var i = 0; i < alvos.length && !alvo; i++) {
        if (alvos[i] && !alvos[i].disabled && alvos[i].offsetParent !== null) alvo = alvos[i];
      }
      if (!alvo) {
        alvo = this.oferta;
        if (!alvo.hasAttribute('tabindex')) {
          alvo.setAttribute('tabindex', '-1');
          alvo.addEventListener('blur', function () { alvo.removeAttribute('tabindex'); }, { once: true });
        }
      }
      alvo.focus({ preventScroll: true });
    }

    comprar(origem) {
      var tons = this.ofertaComTons();
      // Barra (e gaveta) com tons: sem tom ou com a combinação indisponível, abre a gaveta de tom; compra em
      // andamento não faz nada. O botão repetido segue rolando até o quadro, como antes.
      if (tons && origem !== 'repetido' && this.quadroPronto()) {
        var m = this.motivo();
        if (m === 'comprando') {
          this.agendarRedesenho();
          return;
        }
        var r = m === 'sem-tom' || m === 'indisponivel' ? rotuloBarra(this.estadoTons(m)) : null;
        if (r && r.botao.acao === 'abrir') {
          this.abrirGaveta(origem);
          return;
        }
        // Gaveta com o quadro travado por outro motivo (esgotado, degrau indisponível): ela fica aberta e se redesenha,
        // sem rolar a página por baixo dela.
        if (origem === 'gaveta' && m !== null) {
          this.agendarRedesenho();
          return;
        }
      }
      // Quadro com tons ainda sem o script: nada delega (o botão do SSR vem habilitado com o texto de compra).
      if (this.ofertaBloqueada() || (tons && !this.quadroPronto())) {
        if (this.oferta) {
          this.oferta.scrollIntoView({ behavior: reduzMovimento() ? 'auto' : 'smooth', block: 'center' });
          this.focarOferta();
        }
        return;
      }
      // Da gaveta: ela fecha (e destrava a página) antes de delegar, para o carrinho abrir sobre a página.
      if (origem === 'gaveta') this.fecharGaveta({ foco: false });
      this.botaoOferta.click();
      this.dispatchEvent(new CustomEvent('pdp-cta:comprou', { detail: { origem: origem }, bubbles: true }));
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({ event: 'pdp_v2_cta', origem: origem });
      if (typeof window.clarity === 'function') window.clarity('event', 'pdp_v2_cta_' + origem);
    }
  }

  customElements.define('pdp-cta', PdpCta);

  // "Adicionar o combo" da janela do "Conhecer" (PDP v2 da Renata, decisão do Breno de 13/10): o
  // rodapé do combo do snippets/biobio-quick-shop-content.liquid (view quick-shop-combo), no lugar
  // da compra avulsa. O clique fecha a janela pelo próprio botão de fechar do drawer do Trio (o
  // assets/biobio-trio.js devolve o scroll, o inert e o foco) e aciona o botão de adicionar da
  // oferta da página, o mesmo caminho do <pdp-cta>: o <pdp-offer> faz o /cart/add.js com os line
  // items e abre a gaveta do carrinho. Oferta travada (esgotado, avise-me, tom por escolher): nada é
  // adicionado; a página rola até a oferta e o foco vai para o quadro de compra. Delegado no
  // document porque o botão só existe depois de o fragmento ser injetado. Um listener só: o guard
  // do customElements.get('pdp-cta') lá em cima sai antes daqui quando o arquivo carrega de novo.
  function quadroTravado(botao) {
    if (!botao || botao.disabled) return true;
    if (botao.getAttribute('aria-disabled') === 'true') return true;
    return botao.offsetParent === null;
  }

  function focarQuadro(oferta, botao) {
    var alvos = [oferta.querySelector('[data-pdp-avise-open]'), botao];
    var alvo = null;
    for (var i = 0; i < alvos.length && !alvo; i++) {
      if (alvos[i] && !alvos[i].disabled && alvos[i].offsetParent !== null) alvo = alvos[i];
    }
    if (!alvo) {
      alvo = oferta;
      if (!alvo.hasAttribute('tabindex')) {
        alvo.setAttribute('tabindex', '-1');
        alvo.addEventListener('blur', function () { alvo.removeAttribute('tabindex'); }, { once: true });
      }
    }
    alvo.focus({ preventScroll: true });
  }

  document.addEventListener('click', function (event) {
    var botao = event.target && event.target.closest ? event.target.closest('[data-pdp-qs-combo]') : null;
    if (!botao) return;
    event.preventDefault();
    var drawer = botao.closest('[data-trio-drawer]') || document.querySelector('[data-trio-drawer]');
    var fechar = drawer ? drawer.querySelector('[data-trio-drawer-close]') : null;
    if (fechar) fechar.click();
    var oferta = document.querySelector('pdp-offer');
    if (!oferta) return;
    var adicionar = oferta.querySelector('[data-pdp-add-to-cart]');
    if (quadroTravado(adicionar)) {
      oferta.scrollIntoView({ behavior: reduzMovimento() ? 'auto' : 'smooth', block: 'center' });
      focarQuadro(oferta, adicionar);
      return;
    }
    adicionar.click();
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ event: 'pdp_v2_cta', origem: 'janela' });
    if (typeof window.clarity === 'function') window.clarity('event', 'pdp_v2_cta_janela');
  });
})();

/* Altura do cabeçalho do tema para a galeria presa. O cabeçalho do tema é fixo (sticky) e muda de altura entre
   55 e 92 px conforme a largura (o menu quebra em duas linhas); a galeria lê --pdp-cabecalho-h para não ficar
   por baixo dele. Bloco próprio: o arquivo acima sai cedo quando o script carrega de novo. */
(function () {
  if (typeof document === 'undefined' || typeof window === 'undefined' || typeof document.querySelector !== 'function') return;
  if (window.__pdpCabecalhoInit) return;
  window.__pdpCabecalhoInit = true;
  var cabecalho = document.querySelector('.section-header');
  if (!cabecalho) return;
  function medir() {
    var pos = window.getComputedStyle(cabecalho).position;
    var altura = pos === 'sticky' || pos === 'fixed' ? Math.round(cabecalho.getBoundingClientRect().height) + 'px' : '0px';
    document.documentElement.style.setProperty('--pdp-cabecalho-h', altura);
  }
  medir();
  if (typeof ResizeObserver === 'function') new ResizeObserver(medir).observe(cabecalho);
  else window.addEventListener('resize', medir);
})();

/* Galeria presa da Base solta na primeira faixa (27/10/2026, decisão do Breno: "Galeria sobe com a rotina"). No
   desktop a galeria fica presa enquanto a coluna de compra rola; sem isto, as faixas de largura total (a primeira é
   a rotina, levada para depois do frete pela grade da Base) passavam por cima dela como cortina, e a foto parecia
   cortada. O sticky para quando a margem de baixo da galeria encosta no fim da .product-container: uma margem do
   tamanho da distância entre o topo da primeira faixa e o fim da linha, mais 24 px de folga, faz a galeria sair
   junto com a faixa, 24 px acima dela. Medido quando a coluna ou a galeria mudam de altura (ResizeObserver), sem
   ouvir a rolagem; o CSS lê --pdp-galeria-solta só a partir de 768 px, o mesmo corte do sticky. Sem faixa, sem
   :has ou sem JS, nada é escrito e fica a cortina. Os seletores de faixa são os invólucros que a cortina do
   biobio-pdp-v2.css pinta de branco (se mudar lá, muda aqui). */
(function () {
  if (typeof document === 'undefined' || typeof window === 'undefined' || typeof document.querySelector !== 'function') return;
  if (window.__pdpGaleriaSoltaInit) return;
  window.__pdpGaleriaSoltaInit = true;
  var FAIXA = 'div:has(> section[class*="pdp-"]), div:has(> .product-stories-videos), div:has(> .compre-junto), div:has(> pdp-complementares), div:has(> pdp-cta:not([hidden]))';
  var FOLGA = 24;
  var largo = typeof window.matchMedia === 'function' ? window.matchMedia('(min-width: 768px)') : null;
  // A galeria montada agora: { galeria, coluna, linha, ro }. O editor de temas troca os nós da seção do produto
  // (shopify:section:unload e :load, os mesmos eventos que o theme.js e o biobio-trio.js tratam), então o guard
  // global só registra os ouvintes, e a galeria é montada de novo a cada load.
  var atual = null;
  function medir() {
    if (!atual) return;
    var galeria = atual.galeria;
    function limpar() { galeria.style.removeProperty('--pdp-galeria-solta'); }
    if (!largo || !largo.matches) return limpar();
    var topo = Infinity;
    try {
      Array.prototype.forEach.call(atual.coluna.children, function (filho) {
        if (filho.matches(FAIXA) && filho.getClientRects().length) topo = Math.min(topo, filho.getBoundingClientRect().top);
      });
    } catch (e) {
      return limpar();
    }
    if (topo === Infinity) return limpar();
    // O fim vem dos irmãos da galeria na linha (o float da coluna de compra), nunca do fundo da própria linha: a
    // margem da galeria estica a linha, e medir por ela realimentava a conta (27/10, a 1440: 6.495 px gravados no
    // lugar de 5.637 depois de um estado intermediário do carregamento, e a galeria soltava antes da hora).
    var fim = -Infinity;
    Array.prototype.forEach.call(atual.linha.children, function (irmao) {
      if (irmao === galeria || !irmao.getClientRects().length) return;
      fim = Math.max(fim, irmao.getBoundingClientRect().bottom + (parseFloat(window.getComputedStyle(irmao).marginBottom) || 0));
    });
    if (fim === -Infinity) return limpar();
    // Teto: a caixa de margem da galeria, no lugar estático (topo da linha), não passa do fim dos irmãos; assim a
    // linha nunca cresce por causa da margem.
    var topoLinha = atual.linha.getBoundingClientRect().top + (parseFloat(window.getComputedStyle(atual.linha).paddingTop) || 0);
    var teto = fim - (topoLinha + galeria.getBoundingClientRect().height);
    var margem = Math.round(Math.min(fim - topo + FOLGA, teto));
    if (margem > 0) galeria.style.setProperty('--pdp-galeria-solta', margem + 'px');
    else limpar();
  }
  function desmontar() {
    if (!atual) return;
    if (atual.ro) atual.ro.disconnect();
    atual.galeria.style.removeProperty('--pdp-galeria-solta');
    atual = null;
  }
  function montar() {
    var oferta = document.querySelector('.product-details .pdp-offer--layout');
    var coluna = oferta && oferta.closest('.product-details');
    var linha = coluna && coluna.closest('.product-container');
    var galeria = linha && linha.querySelector(':scope > .product-gallery');
    if (atual && atual.galeria === galeria) return medir();
    desmontar();
    if (!galeria) return;
    atual = { galeria: galeria, coluna: coluna, linha: linha, ro: null };
    medir();
    if (typeof ResizeObserver === 'function') {
      atual.ro = new ResizeObserver(medir);
      atual.ro.observe(coluna);
      atual.ro.observe(galeria);
    }
    ligarJanela();
  }
  // Ouvintes da janela e do corte de 768 px: uma vez só, e só quando há galeria da Base (as outras PDPs v2 não
  // ganham ouvinte nenhum). O medir() sai cedo sem galeria montada.
  var janelaLigada = false;
  function ligarJanela() {
    if (janelaLigada) return;
    janelaLigada = true;
    if (largo && typeof largo.addEventListener === 'function') largo.addEventListener('change', medir);
    if (typeof ResizeObserver !== 'function') {
      window.addEventListener('resize', medir);
      window.addEventListener('load', medir);
    }
  }
  montar();
  if (typeof document.addEventListener === 'function') {
    document.addEventListener('shopify:section:unload', function (e) {
      if (atual && e && e.target && typeof e.target.contains === 'function' && e.target.contains(atual.galeria)) desmontar();
    });
    document.addEventListener('shopify:section:load', montar);
  }
})();
